import React, {createContext, useContext, useEffect, useState} from 'react';
const NavigationContext=createContext(null);
export function EssenceNavigationProvider({children}) {
  const [section,setSection]=useState(null);
  return <NavigationContext.Provider value={{section,setSection}}>{children}</NavigationContext.Provider>;
}
export function useEssenceSection(){return useContext(NavigationContext)?.section;}
export function useEssenceNavigation(section){
  const setSection=useContext(NavigationContext)?.setSection;
  useEffect(()=>{setSection?.(section);return ()=>setSection?.(null);},[section,setSection]);
}
